export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-831J6L0ZZ0';

export const isAnalyticsEnabled = () =>
  process.env.NODE_ENV === 'production' && Boolean(GA_MEASUREMENT_ID);

let initialized = false;
let initPromise = null;

const loadGtagScript = () =>
  new Promise((resolve) => {
    if (typeof window.gtag === 'function') {
      resolve();
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });

export const initAnalytics = () => {
  if (!isAnalyticsEnabled()) {
    return Promise.resolve();
  }

  if (initialized) {
    return Promise.resolve();
  }

  if (!initPromise) {
    initPromise = loadGtagScript().then(() => {
      window.gtag('js', new Date());
      initialized = true;
    });
  }

  return initPromise;
};

export const trackPageView = (pagePath) => {
  if (!isAnalyticsEnabled() || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
  });
};
